import React from 'react';

const DefaultContainer = props => (
  <div className="x-default-container" id={props.id} {...props}>
    { props.children}
  </div>
);

export default DefaultContainer;
